(function (Drupal, once) {
  Drupal.behaviors.aboutPageLayoutToggle = {
    attach: function (context, settings) {
      // Run this code only once per page load
      once('about-layout-toggle', 'body', context).forEach(function () {

        function toggleLayout() {
          const isLarge = window.innerWidth >= 992;
          const parallax = document.getElementById("about-parallax");
          const staticView = document.getElementById("about-static");

          if (parallax && staticView) {
            parallax.style.display = isLarge ? "none" : "block";
            staticView.style.display = isLarge ? "block" : "none";
          }
        }

        // Initial check
        toggleLayout();

        // Listen for window resize
        window.addEventListener("resize", toggleLayout);
      });
    }
  };
})(Drupal, once);
